import { combineEpics } from 'redux-observable';
import { trackLocationChangeEpic } from './track-location-change';
import { identifyUserEpic } from './identify-user';
import { resetOnLogoutEpic } from './reset-on-logout';
import { identifyArtistEpic } from './identify-artist';
import { identifyArtistPlanEpic } from './identify-artist-plan';
import { identifyRudderstackArtistEpic } from './identify-rudderstack-artist';
import { identifyArtistSubscriptionEpic } from './identify-artist-subdomain';

import { trackAccountCreatedSuccess } from './auth/track-account-created-success';
import { trackSignUpSuccess } from './auth/track-sign-up-success';
import { trackSignInSuccess } from './auth/track-sign-in-success';
import { trackSignOutSuccess } from './auth/track-sign-out';
import { trackArtistCreatedSuccess } from './artist/artist-created';
import { trackPlanSelected } from './subscriptions/plan-selected';
import { trackCheckoutViewed } from './checkout/checkout-viewed';
import { trackCheckoutStarted } from './checkout/checkout-started';
import { trackCheckoutCompleted } from './checkout/checkout-completed';
import { trackInviteSent } from './invites/track-invite-sent';
import { trackUpgrade } from './subscriptions/track-upgrade';
import { trackDowngrade } from './subscriptions/track-downgrade';
import { trackMicrositeUpdated } from './microsite/track-microsite-updated';
import { trackMicrositePublished } from './microsite/track-microsite-published';
import { trackCollaboratorAdded } from './collaborators/track-collaborator-added';
import { trackCollaboratorRemoved } from './collaborators/track-collaborator-removed';
import { trackOwnerAdded } from './owners/track-owners-added';
import { trackOwnerRemoved } from './owners/track-owners-removed';
import { trackReleaseStarted } from './release/track-release-started';
import { trackReleasePublished } from './release/track-release-published';
import { trackReleaseUpdated } from './release/track-release-updated';
import { trackReleaseRemoved } from './release/track-release-removed';
import { trackReleaseCreated } from './release/track-release-created';
import { trackGenreUpdated } from './release/track-release-genre-updated';
import { trackReleaseShared } from './release/track-release-shared';
import { trackTraclinkCreated } from './traclink/track-traclink-created';
import { trackArtistDeactivatedSuccess } from './artist/artist-deactivated';
import { trackUserDeletedSuccess } from './user/user-deleted';
import { trackReleasePaidItems } from './release/track-release-payments';
import { trackFieldUpdated } from './release/track-release-field-updated';
import { trackReleaseInputFieldUpdated } from './release/trac-release-input-field-updated';
import { merchProductStarted } from './merch/merch-product-started';
import { merchProductCreated } from './merch/merch-product-created';
import { merchProductChangeColor } from './merch/merch-product-change-color';
import { merchProductTakeDown } from './merch/merch-product-takedown';
import { merchProductUpdateDesignPosition } from './merch/merch-product-update-merch-design-position';
import { merchProductUpdateOwnership } from './merch/merch-product-update-ownership';
import { merchProductUpdated } from './merch/merch-product-updated';
import { merchProductImageUpload } from './merch/merch-product-upload-image';
import { trackUpdateReleaseStoreError } from './release/track-release-store-error';
import { updateMerchProductError } from './merch/merch-update-product-error';
import { releaseTrackFieldUpdated } from '@webapp/store/analytics/effects/track/track-field-updated';
import { trackTracpageFieldUpdated } from './tracpage/trac-page-updated';
const analyticsEpic = combineEpics(
  // Page Tracking
  trackLocationChangeEpic,

  // User Identifying
  identifyUserEpic,

  // Artist Identifying
  identifyArtistEpic,
  identifyArtistPlanEpic,
  identifyArtistSubscriptionEpic,

  // Artist Rudderstack Identifying
  identifyRudderstackArtistEpic,

  // Auth events
  trackAccountCreatedSuccess, // User Account Created
  trackSignUpSuccess, // Signed Up
  trackSignInSuccess, // Signed In
  trackSignOutSuccess, // Signed Out

  // User events
  trackUserDeletedSuccess, // User Delete Success

  // Artist events,
  trackArtistCreatedSuccess, // Artist Profile Added
  trackArtistDeactivatedSuccess, // Account Deactivated (Artist)

  // Subscriptions
  trackPlanSelected, // Plan Selected
  trackDowngrade, // Plan Downgraded
  trackUpgrade, // Plan Upgraded

  // Checkout
  trackCheckoutViewed, // Checkout Step Viewed
  trackCheckoutStarted, // Checkout Started
  trackCheckoutCompleted, // Checkout Step Completed

  // Collaborators
  trackCollaboratorAdded, // Collaborator Added
  trackCollaboratorRemoved, // Collaborator Removed

  // Owners
  trackOwnerAdded, // Collaborator Added
  trackOwnerRemoved, // Collaborator Removed

  // Release
  trackReleaseStarted, // Release Started
  trackReleaseCreated, // Release Draft Created
  trackGenreUpdated, // Genre selected
  trackReleasePublished, // Release Completed
  trackReleaseUpdated, // Release Updated
  trackReleaseRemoved, // Release Removed
  trackReleaseShared, // Release Shared
  trackReleasePaidItems, // One time payments
  trackFieldUpdated, // Field Updated
  trackReleaseInputFieldUpdated, // Release Input field updated
  trackUpdateReleaseStoreError, // Update Store Error

  //Track
  releaseTrackFieldUpdated, // Field Updated
  trackCollaboratorAdded, // Collaborator Added

  // Traclink
  trackTraclinkCreated, // Traclink Created

  // Invites
  trackInviteSent, // Invite Sent

  // Microsite
  trackMicrositeUpdated, // Microsite Updated
  trackMicrositePublished, // Microsite Published

  // Logout
  resetOnLogoutEpic,

  // Merch
  merchProductStarted, // Merch Procuct start
  merchProductCreated, // Merch Procuct created
  merchProductChangeColor, // Merch Procuct update
  merchProductTakeDown, // Merch Procuct taken down
  merchProductUpdateDesignPosition, // Merch Procuct update
  merchProductUpdateOwnership, // Merch Procuct update
  merchProductUpdated, // Merch Procuct update
  merchProductImageUpload, // Merch Procuct update
  updateMerchProductError, // Merch Procuct update Error

  trackTracpageFieldUpdated
);

export default analyticsEpic;
